import React from 'react'
import { Link } from "react-router-dom";
import stripHtml from "../utils/stripHtml";

// handle mouse enter
const handleMouseEnter = (e) => {
    const vid = e.target
    vid.muted = true
    vid.play()
}
// handle mouse leave
const handleMouseLeave = (e) => {
    const vid = e.target
    vid.muted = false
    vid.currentTime = 0
    vid.pause()
}

const SuggestVideo = ({ data }) => (

    <div className="sv-suggest">
        <Link to={`/video/${data?.id}`} className="sv-suggest-thumb" aria-label="Watch video">
            {data.videos?.slice(0).map((getVideo, i) => (
                getVideo.video_status && getVideo.video_status !== 'ready' ? (
                    <div key={i} className="sv-suggest-status">
                        {getVideo.video_status === 'failed' ? (
                            <i className="fa-solid fa-circle-exclamation" style={{ fontSize: 18, color: '#ef4444' }}></i>
                        ) : (
                            <div className="spinner-border text-light spinner-border-sm" role="status">
                                <span className="visually-hidden">Processing...</span>
                            </div>
                        )}
                        <div className="mt-1">
                            {getVideo.video_status === 'failed' ? 'Failed' : 'Processing...'}
                        </div>
                    </div>
                ) : (
                    <video key={i}
                        controls={false}
                        disableRemotePlayback
                        disablePictureInPicture
                        preload="metadata"
                        poster={`${getVideo.thumbnail}`}
                        onContextMenu={(e) => e.preventDefault()}
                        src={`${getVideo.video_stream}`}
                        className="sv-suggest-video"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    />
                )
            ))}
        </Link>
        <div className="sv-suggest-text">
            <Link to={`/video/${data.id}`} className="sv-suggest-title">
                {stripHtml(data.details) !== "" ? stripHtml(data.details) : data.post_by}
            </Link>
            <Link to={`/contact/${data?.user_id}`} className="sv-suggest-meta">{data.post_by}</Link>
            <div className="sv-suggest-meta">
                {data.totalLikes} Loves
                <span className="vp-dot" aria-hidden="true">·</span>
                {data.post_time}
            </div>
        </div>
    </div>
)
export default React.memo(SuggestVideo)
